module.exports = __webpack_public_path__ + "img/art.4daa75e3.jpg";